
export default {
  props: {
    imageName: String,
    altText: String,
    title: String,
    contactType: String,
    phoneNumber: String,
  },
  computed: {
    phoneURl: function () {
      return "tel:" + this.phoneNumber.replace(/-/g, "");
    },
  },
};
